export const tableHeader = ['Select', 'Question Code', 'Url', 'View']

export const initialState = {
  courseId: '',
  subjectId: '',
  chapterId: '',
  topicId: ''
}
